import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class ChartsBarChartROIComponent extends Component {
  @service initiativeSlideover;

  get disabled() {
    return this.args.source == undefined;
  }

  @action
  clickHandler(params) {
    const initiative_id = params.seriesId;
    this.initiativeSlideover.open(initiative_id);
  }

  @action
  onLinkMetricClick() {
    return this.args?.onLinkMetricClick();
  }
}
